import React, { Component} from "react";
import { NavLink } from "react-router-dom";
import Features from "../features"
import {Container} from 'reactstrap'

class CarCard extends Component{

    render(){
      const {nbrPerson,nbrPorte,AC,energie} = this.props
        return (
          <NavLink to={this.props.carLink} className="typeLink">
            <div
              id="typeCard"
              className="d-flex flex-column overflow-hidden justify-content-between"
            >
              <img
                className="typeImg img-fluid"
                src={this.props.img}
                alt={this.props.name}
              />
              <Container className="features">
                <Features id="features" 
                nbrPerson={nbrPerson||4}
                nbrPorte = {nbrPorte||4}
                energie={energie}
                AC={AC}
                />
              </Container>

              <div className="d-flex flex-column justify-content-center text-center cardInfos">
                <p className="cardText">{this.props.name}</p>
                <p className="priceText">{this.props.price}</p>
              </div>
            </div>
          </NavLink>
        );
    }
}

export default CarCard;